import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { getEngagement, listEngagementResponses, submitEngagementResponse } from '../../../api';
import { useAlerts } from '../../../alerts';
import { AnonymityRefresher, Button, EncouragementNote, EngagementQuestionForm } from '../../../components';
import Markdown from 'react-markdown';

const Survey = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setError, clearErrors } = useAlerts();
  
  const [engagement, setEngagement] = useState(null);
  const [engagementResponses, setEngagementResponses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inResponseMode, setInResponseMode] = useState(false);
  const [showEncouragementNote, setShowEncouragementNote] = useState(false);

  useEffect(() => {
    getEngagement(id).then(engagement => {
      setEngagement(engagement);
    }).catch(error => {
      setError(error ?? 'Failed to load engagement');
    });

    refreshResponses();
    
    return () => clearErrors();
  }, []);

  const refreshResponses = () => {
    listEngagementResponses(id).then(responses => {
      setEngagementResponses(responses);
    }).catch(error => {
      setError(error ?? 'Failed to load engagement responses');
    });
  }

  const onSubmit = (questionResponses) => {
    setIsLoading(true);

    submitEngagementResponse(id, questionResponses).then(() => {
      setInResponseMode(false);
      setShowEncouragementNote(true);
    }).catch(error => {
      setError(error ?? 'Failed to submit survey');
    }).finally(() => setIsLoading(false));
  }

  const onCloseEncouragementNote = () => {
    if (engagement.getMaxSubmissions() - engagementResponses.length <= 1) {
      navigate('/home');
    } else {
      setShowEncouragementNote(false);
      refreshResponses();
    }
  }

  return (
    <Container>
      {/* Encouragement Note */}
      <EncouragementNote
        isVisible={showEncouragementNote}
        onClose={onCloseEncouragementNote}>
        <Markdown>{engagement?.getEncouragementNote()}</Markdown>
      </EncouragementNote>

      {/* Title */}
      <Typography variant='h1' gutterBottom>Survey</Typography>

      {/* Survey Questions / Responses */}
      {engagementResponses?.length === 0 || inResponseMode ? (
        <>
          {/* Anonymity Refresher */}
          <AnonymityRefresher style={{ marginBottom: '5px' }} />

          {/* Survey Questions */}
          <EngagementQuestionForm
            engagementQuestions={engagement?.getQuestions()}
            onSubmit={onSubmit}
            isLoading={isLoading}
          />
        </>
      ) : (
        <>
          {/* Survey Responses */}
          {engagementResponses.map((response, index) => (
            <div key={index} style={{ backgroundColor: '#f0f0f0', padding: '20px', marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant='body1' style={{ textAlign: 'center' }}>Survey completed on {response.getCreatedAt()?.toLocaleString()}</Typography>
            </div>
          ))}

          {/* Additional Response Button */}
          {engagementResponses.length < engagement?.getMaxSubmissions() && (
            <Button secondary fullWidth style={{ marginTop: '1em' }} onClick={() => setInResponseMode(true)}>Submit Another Response</Button>
          )}

          <Button component={Link} to='/home' style={{ marginTop: '1em' }} fullWidth>
            Done
          </Button>
        </>
      )}
    </Container>
  );
}
export default Survey;